import { IndexedDbPersistenceLayer } from './IndexedDbPersistenceLayer';

/**
 * The web app's IndexedDB storage. Browser windows share it, but only the cache keeps them in sync:
 * - every write to the sync queue starts a window's sync worker, and each pass of that worker
 *   clears the in-progress flags of records another window is uploading;
 * - a window that changes identity (logout, org switch, impersonation) clears the cache and then
 *   reloads the other windows into the new identity (useClearCache); syncing the session live
 *   would switch them first, with the previous identity's data still in memory.
 */
export const createWebPersistenceLayers = () => ({
  cache: new IndexedDbPersistenceLayer(),
  sync: new IndexedDbPersistenceLayer('sync-records', 'kai-sync', { syncAcrossWindows: false }),
  auth: new IndexedDbPersistenceLayer('auth-records', 'kai-auth', { syncAcrossWindows: false }),
});
